import { CombinedStylesConfig } from "../Select/types";

const PURPLE_BASE = "#4D2481";
const GRAY_BASE = "rgba(0, 0, 0, 0.20)";
const GRAY_LIGHTER = "rgba(0, 0, 0, 0.10)";
const WHITE_PINK = "#FFFBFF";

const MENU_MAX_HEIGHT = "300px";
const DEFAULT_BORDER_RADIUS = "8px";
const INPUT_HEIGHT = "32x";
const BORDER_THICKNESS = "1px";
const SCROLLBAR_SIZE = "0px";

export const OUTSIDE_VALUES_SELECT_STYLES: CombinedStylesConfig = {
  input: (baseStyles) => ({
    ...baseStyles,
    padding: "0px",
    backgroundColor: WHITE_PINK,
  }),
  control: (baseStyles, state) => ({
    ...baseStyles,
    minHeight: INPUT_HEIGHT,
    display: "flex",
    alignItems: "center",
    justifyItems: "center",
    border: `${BORDER_THICKNESS} solid ${GRAY_BASE}`,
    cursor: "pointer",
    borderRadius: state.menuIsOpen
      ? `${DEFAULT_BORDER_RADIUS} ${DEFAULT_BORDER_RADIUS} 0px 0px`
      : `${DEFAULT_BORDER_RADIUS}`,
    boxShadow: "none",
    padding: "0px",
    "&:hover": {}, // empty obj - no styles
  }),
  option: () => ({
    padding: "8px 12px",
    borderRadius: DEFAULT_BORDER_RADIUS,
    cursor: "pointer",
    "&:hover": { backgroundColor: GRAY_LIGHTER },
  }),
  menu: (baseStyles) => ({
    ...baseStyles,
    boxShadow: "none",
    margin: "0",
  }),
  menuList: (baseStyles) => ({
    ...baseStyles,
    backgroundColor: WHITE_PINK,
    display: "flex",
    flexDirection: "column",
    maxHeight: MENU_MAX_HEIGHT,
    border: `${BORDER_THICKNESS} solid ${GRAY_BASE}`,
    borderRadius: `0px 0px ${DEFAULT_BORDER_RADIUS} ${DEFAULT_BORDER_RADIUS}`,
    gap: "8px",
    padding: "8px",
    color: PURPLE_BASE,
    "::-webkit-scrollbar": {
      width: SCROLLBAR_SIZE,
      height: SCROLLBAR_SIZE,
    },
  }),
  valueContainer: (baseStyles) => ({
    ...baseStyles,
    padding: "0px 12px",
    gap: "5px",
  }),
  indicatorsContainer: () => ({ display: "none" }),
};
